import Pagination from './pagination.vue'

export default Pagination
